import React from 'react';
import { css } from '@emotion/react';
import { EditorState, Modifier } from 'draft-js';

import { Mentionable } from '../types';
import { MentionList } from './MentionList';
import { DraftJsStyleButtonProps } from '../DraftJSPlugins/draft-js-buttons/src';
import DropdownComponent, { DropdownPropsRef } from '../../Input/Basics/DropdownComponent';
import { Popup } from '../../Popup';

export const AddMentionButton: React.FC<
  DraftJsStyleButtonProps & {
    mentions: Mentionable[];
    isRtl?: boolean;
  }
> = ({ setEditorState, getEditorState, mentions, isRtl }) => {
  const ref = React.useRef<DropdownPropsRef>(null);

  const onClose = React.useCallback(() => {
    ref.current?.close();
  }, []);

  const onClickMention = React.useCallback(
    (mention: Mentionable) => {
      const editorState = getEditorState();
      const currentContent = editorState.getCurrentContent(),
        currentSelection = editorState.getSelection();

      const newContent = Modifier.insertText(
        currentContent,
        currentSelection,
        mention.value ?? mention.name,
        undefined,
        undefined
      );

      let newEditorState = EditorState.push(editorState, newContent, 'insert-characters');
      newEditorState = EditorState.forceSelection(newEditorState, newContent.getSelectionAfter());
      setEditorState(newEditorState);
      onClose();
    },
    [getEditorState, setEditorState, onClose]
  );

  return (
    <DropdownComponent
      ref={ref}
      css={css`
        position: initial;
      `}
      className='add-mention-button'
      closeOnSelect={false}
    >
      <DropdownComponent.Reference>
        <Popup
          className='ml-0'
          content='Insert merge field'
          hoverable
          trigger={
            <div
              className='flex justify-center items-center'
              onMouseDown={(e) => e.preventDefault()}
              css={css`
                padding: 0.25rem;
                height: 3rem;
                width: 3rem;
                color: #222222;
                font-size: 18px;
                transition:
                  background-color 0.2s,
                  color 0.2s;
                border-radius: 0.25rem;
                cursor: pointer;
                &:hover {
                  background: #707070;
                  color: #fff;
                }
              `}
            >
              <b>{`{}`}</b>
            </div>
          }
        />
      </DropdownComponent.Reference>
      <DropdownComponent.Options placement='top'>
        <MentionList
          isRtl={isRtl}
          mentions={mentions}
          onClickMention={onClickMention}
          onClose={onClose}
        />
      </DropdownComponent.Options>
    </DropdownComponent>
  );
};
